import { RouteStatus } from "@/data/trip";

export const PlannedRouteMessage =
  "This route is planned and will automatically become active once the truck completes all of previous routes.";

export const TripMonitorHiddenRouteStatuses = [RouteStatus.cancelled, RouteStatus.completed];
